import styled from '@emotion/styled'

import { spacing } from '../../theme'

type Spacing = keyof typeof spacing

/**
 * Spacer is a component that creates a vertical space between elements.
 * @param size - The size of the spacer.
 * @returns A styled div with the height of the spacer.
 * @example
 * <Spacer size="s" />
 * <Spacer size="m" />
 * <Spacer size="l" />
 */
const Spacer = styled.div<{ size: Spacing }>`
  ${props => {
    return `height: ${spacing[props.size]};`
  }}
`

export default Spacer
